import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

// Each Dashboard section's heading is the tap-through to the page that holds its detail.
export function SectionLink({ to, label, aside }: { to: string; label: string; aside?: string }) {
  return (
    <Link
      to={to}
      className="flex min-h-10 items-center justify-between gap-3 text-[var(--fl-text-2)] hover:text-[var(--fl-heading)] transition-colors"
    >
      <span className="text-[11px] font-semibold uppercase tracking-wider lg:text-xs">{label}</span>
      <span className="flex min-w-0 items-center gap-2 text-xs lg:text-[13px]">
        {aside && <span className="truncate">{aside}</span>}
        <ChevronRight size={18} className="shrink-0 text-[var(--fl-text-3)]" aria-hidden="true" />
      </span>
    </Link>
  )
}

export const SECTION_CLASS = 'border-t border-[var(--fl-divider)] pt-1 pb-3 lg:pt-2 lg:pb-3.5'
